import { CmsPageResponse } from './cms-types';

const CMS_BASE_URL =
  'https://stashback.missionimpact.partners/api/public/cms/sites/sync.datamission.io';

/**
 * Fetches a CMS page by its path slug and locale.
 * The CMS API returns page metadata, SEO data, and zone components
 * that drive the landing page content. Passing a locale query param
 * returns the translated version of the page content.
 *
 * @param pageSlug - The page path slug (e.g. '/' for home). Defaults to '/'.
 * @param locale - The locale code (e.g. 'en', 'fr', 'de', 'es'). Defaults to 'en'.
 * @returns The full CMS page response including zones with component data.
 */
export async function fetchCmsPage(
  pageSlug = '/',
  locale = 'en'
): Promise<CmsPageResponse> {
  const url = `${CMS_BASE_URL}/pages${pageSlug}?locale=${encodeURIComponent(locale)}`;
  const response = await fetch(url);

  if (!response.ok) {
    // eslint-disable-next-line no-restricted-syntax
    throw new Error(`CMS fetch failed: ${String(response.status)} ${response.statusText}`);
  }

  return (await response.json()) as CmsPageResponse;
}
